import { observer } from "mobx-react";
import MainLayout from "newApp/components/layouts/MainLayout";
import SiteNavigator from "newApp/components/SiteNavigator";
import TechSupportNavigator from "newApp/components/TechSupportNavigator";
import FlexColumn from "newApp/kit/components/FlexColumn";
import H1 from "newApp/kit/components/H1";
import React from "react";

const TechSupportPage: React.FC = () => {
  return (
    <MainLayout>
      <H1>Вопросы личного кабинета</H1>
      <FlexColumn>
        <SiteNavigator />
        <TechSupportNavigator />
      </FlexColumn>
    </MainLayout>
  );
};

export default observer(TechSupportPage);
